/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Import_Tile_EbranaInputs */

const cs_import_tile_ebrana = /** @type {(inputs: Import_Tile_EbranaInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`eBrána`)
};

const en_import_tile_ebrana = /** @type {(inputs: Import_Tile_EbranaInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`eBrána`)
};

/**
* | output |
* | --- |
* | "eBrána" |
*
* @param {Import_Tile_EbranaInputs} inputs
* @param {{ locale?: "cs" | "en" }} options
* @returns {LocalizedString}
*/
export const import_tile_ebrana = /** @type {((inputs?: Import_Tile_EbranaInputs, options?: { locale?: "cs" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Import_Tile_EbranaInputs, { locale?: "cs" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_import_tile_ebrana(inputs)
	return cs_import_tile_ebrana(inputs)
});